import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=20b8749a"
import script from "./Print.vue?vue&type=script&lang=js"
export * from "./Print.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports